export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getOrders($state) {
    return Object.values($state.orders).sort((a, b) => a.id - b.id);
  },
  searchProducts($state) {
    return Object.values($state.products).sort((a, b) => a.id - b.id);
  },
};
